<style>
    .submit_form {
        margin: auto;
        display: flex;
        flex-direction: column;
        text-align: center;
        padding-bottom: 20px;
    }
    .submit_info {
        width: 350px;
        display: flex;
        flex-direction: column;
        margin: auto;
    }
    .middle .submit_info{
        width: 300px;
    }
    .submit_title {
         font-family: Gotham Pro, sans-serif;
         font-weight: 500;
         font-size: 18px;
         line-height: 17px;
         text-align: center;
         color: #404455;
    }
    .submit_form_inputs {
        margin: auto;
        display: flex;
        flex-direction: column;
        text-align: center;
        margin-top: 0;
    }
    .hands {
        width: 70px;
        height: 70px;
        background-image: url("./images/hands.svg");
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        margin: 20px auto 50px auto;
    }
    button.submit_btn {
        background: #FF0000;
        border: 1px solid #FF0000;
        box-sizing: border-box;
        border-radius: 5px;
        width: 176px;
        height: 50px;
        margin: auto;
        font-family: Gotham Pro, sans-serif;
        font-style: normal;
        color: #FFFFFF;
        float: right;
        cursor: pointer;
        transition: 0.25s;
        font-weight: 500;
        font-size: 16px;
        line-height: 15px;
        text-align: center;
    }

    button.submit_btn:hover {
        background-color: #DD0000;
        color: #FFFFFF;
    }
    button.submit_btn:active, button.submit_btn:focus {
        background-color: #ff0000;
        color: #FFFFFF;
        box-shadow: 0 0 0 0.2rem #ff000060;
    }
    button.submit_btn_prev {
        background: #ffffff;
        color: #FF0000;
        float: left;
        cursor: pointer;
        transition: 0.25s;
    }
    button.submit_btn_prev:hover {
        background-color: #FF0000;
        color: #FFFFFF;
    }
    button.submit_btn_prev:active, button.submit_btn_prev:focus {
        background-color: #FF0000;
        color: #FFFFFF;
        box-shadow: 0 0 0 0.2rem #ff000060;
    }
    .social_area {
        padding-top: 30px;
    }
    .social_area_title {
        font-size: 18px;
        line-height: 17px;
        text-align: center;
        color: #404455;
    }
    .social_area_block {
        display: flex;
        width: 210px;
        margin: 0 auto;
        justify-content: space-between;
        padding-top: 20px;
    }
    .social_area_block.social_area_block_phone {
        width: 160px;
        justify-content: space-around;
    }
    .social_area_block_item {
        width: 38px;
        height: 38px;
        border-radius: 40px;
        border: 1px solid #404455;
        background-repeat: no-repeat;
        background-position: center;
    }
    .social_area_block_item_fb {
        background-image: url("./images/fb.svg");
    }
    .social_area_block_item_vk {
        background-image: url("./images/vk.svg");
    }
    .social_area_block_item_inst {
        background-image: url("./images/inst.svg");
    }
    .social_area_block_item_wapp {
        background-image: url("./images/whatsapp.svg");
        border: 0;
        border-radius: 0;
        background-size: contain;
    }
    .social_area_block_item_phone {
        background-image: url("./images/phone.svg");
        border: 0;
        border-radius: 0;
        background-size: contain;
    }
</style>

<script>
    import { mutations } from '../mainStore.js';
    import { onMount } from "svelte";
    onMount(() => {
        window.scrollTo(0,0)
    });
    function restart() {
        mutations.setStep(1)
        mutations.clearGoodsList()
        mutations.setSelectedItem(null)
    }
</script>

<div class="submit_form">
    <div class="submit_info">
        <div class="submit_title">
            Спасибо за заявку!<br><br>

            Наши менеджеры свяжутся с<br> вами!
        </div>
        <div class="hands"></div>
        <div class="submit_form_inputs">
            <button class="submit_btn submit_btn_prev" on:click="{() => restart()}">
                Собрать новую<br> конфигурацию
            </button>
        </div>
        <div class="social_area">
            <div class="social_area_title">
                8 800 777 42 39
            </div>
            <div class="social_area_block social_area_block_phone">
                <!--<a href="https://api.whatsapp.com/send?phone=7000000000" target="_blank" class="social_area_block_item social_area_block_item_wapp"></a>-->
                <a href="tel:88007774239" class="social_area_block_item social_area_block_item_phone"> </a>
            </div>
        </div>
        <div class="social_area">
            <div class="social_area_title">
                Мы в социальных сетях:
            </div>
            <div class="social_area_block">
                <a href="https://www.facebook.com/EdaNaKolesahcom/" target="_blank" class="social_area_block_item social_area_block_item_fb"> </a>
                <a href="https://vk.com/edanakolesahcom" target="_blank" class="social_area_block_item social_area_block_item_vk">  </a>
                <a href="https://www.instagram.com/eda_na_kolesah_com/" target="_blank" class="social_area_block_item social_area_block_item_inst"> </a>
            </div>
        </div>
    </div>
</div>
